// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"b9754885","117":"9306d109","127":"8815ab25","146":"93586898","286":"db78ab68","453":"d7d70089"}[chunkId] + ".chunk.js";
};